import { render, staticRenderFns } from "./AddBathroom.vue?vue&type=template&id=54947bd6"
import script from "./AddBathroom.vue?vue&type=script&lang=js"
export * from "./AddBathroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54947bd6')) {
      api.createRecord('54947bd6', component.options)
    } else {
      api.reload('54947bd6', component.options)
    }
    module.hot.accept("./AddBathroom.vue?vue&type=template&id=54947bd6", function () {
      api.rerender('54947bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AddBathroom.vue"
export default component.exports